var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeclaracaoDigital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 49,
    viewBox: "0 0 43 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0635 29.9577H16.5362M12.0635 36.6675H23.2452M2 4.23662C2 3.64343 2.23561 3.07454 2.65501 2.65509C3.0744 2.23564 3.64322 2 4.23634 2H37.7814C38.3745 2 38.9433 2.23564 39.3627 2.65509C39.7821 3.07454 40.0177 3.64343 40.0177 4.23662V44.4957C40.0177 45.0889 39.7821 45.6578 39.3627 46.0772C38.9433 46.4967 38.3745 46.7323 37.7814 46.7323H4.23634C3.64322 46.7323 3.0744 46.4967 2.65501 46.0772C2.23561 45.6578 2 45.0889 2 44.4957V4.23662Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11813 3.11829C3.11813 3.11829 7.32804 17.6563 21.0088 17.6563C34.6896 17.6563 38.8995 3.11829 38.8995 3.11829",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0089 22.1296C23.4791 22.1296 25.4816 20.1268 25.4816 17.6563C25.4816 15.1858 23.4791 13.1831 21.0089 13.1831C18.5387 13.1831 16.5363 15.1858 16.5363 17.6563C16.5363 20.1268 18.5387 22.1296 21.0089 22.1296Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9453 2H4.23634C3.64322 2 3.0744 2.23564 2.65501 2.65509C2.23561 3.07454 2 3.64343 2 4.23662V10.9465M31.0724 2H37.7814C38.3745 2 38.9433 2.23564 39.3627 2.65509C39.7821 3.07454 40.0177 3.64343 40.0177 4.23662V10.9465",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclaracaoDigital);
export default __webpack_public_path__ + "static/media/declaracao_digital.b9bd0c04dafd7060799193877fb056b8.svg";
export { ForwardRef as ReactComponent };